import React, { Component, PropTypes } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import SiteSelectorItem from './SiteSelectorItem';
import { displayCreationModal } from 'saas/sites/modals';
import cx from 'classnames';
import { connect } from 'react-redux';
import { addSite, selectSite, unselectSite } from '../actions/sites';
import { getSites } from '../reducers/sites';
import { getSelectedSites, getCustomerId, getErrors } from '../reducers/form';
import { Form } from 'semantic-ui-react';
import Modal from 'common/components/Modal';

class SiteSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this._onAddSite = this._onAddSite.bind(this);
  }

  _onAddSite(evt) {
    evt.stopPropagation();
    evt.preventDefault();

    const onSaved = this.props.onAdded;

    // Displaying site modal
    displayCreationModal(this.props.customer, onSaved);
  }

  shouldComponentUpdate(nextProps) {
    return shallowCompare(this, nextProps);
  }

  render() {
    const { sites, selected, onSelected, onUnselected, errors } = this.props;

    const isSiteSelected = s =>
      selected.some(cs => cs.toString() === s.id.toString());

    const filteredSites = sites.filter(
      s => s.deleted !== true || isSiteSelected(s)
    );

    const hasError = (global = false) => {
      if (errors) {
        return errors.includes('siteIds');
      }
      return false;
    };

    const onSiteUnselect = id => {
      this.setState({
        warningModalOpened: true,
        warningModalSite: id,
      });
    };

    const onSiteChange = (id, value) => {
      if (!value) {
        onSelected(id);
      } else {
        onSiteUnselect(id);
      }
    };

    const segmentClasses = cx('ui segment form', {
      error: hasError(),
    });

    const onModalConfirm = () => {
      const { warningModalSite } = this.state;
      this.setState({
        warningModalOpened: false,
        warningModalSite: undefined,
      });
      onUnselected(warningModalSite);
    };

    const onModalClose = id => {
      this.setState({
        warningModalOpened: false,
        warningModalSite: undefined,
      });
    };

    const { warningModalOpened } = this.state;

    return (
      <div className={segmentClasses}>
        <h3 className="ui header">
          Choix du site
          <button
            className="ui right floated labeled icon button"
            onClick={this._onAddSite}
          >
            <i className="icon add" />
            Créer un nouveau site
          </button>
        </h3>
        {hasError(true) && (
          <div className="ui error message">
            <p>Vous devez sélectionner au moins un site.</p>
          </div>
        )}
        <br />
        <Form.Field required>
          <label>Site(s)</label>
          <Form.Group inline className="ui grid checkBoxList">
            {filteredSites.map(s => (
              <SiteSelectorItem
                key={s.id}
                site={s}
                value={isSiteSelected(s)}
                onChange={onSiteChange}
                error={hasError()}
              />
            ))}
          </Form.Group>
        </Form.Field>
        <Modal
          isOpened={!!warningModalOpened}
          closable
          onConfirm={onModalConfirm}
          onClose={onModalClose}
        >
          <div className="header">Confirmation de suppression</div>
          <div className="content">
            <div>
              Êtes-vous sûr(e) de vouloir décocher ce site ? <br />
              Toutes les informations du diagnostic pour ce site seront perdues
              et si une étude existe, elle sera annulée.
            </div>
          </div>
          <div className="actions">
            <div className="actions">
              <button className="ui button" onClick={onModalClose}>
                Annuler
              </button>
              <button className="ui red button" onClick={onModalConfirm}>
                Confirmer
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

SiteSelector.propTypes = {
  sites: PropTypes.array.isRequired,
  selected: PropTypes.array.isRequired,
  onAdded: PropTypes.func.isRequired,
  onSelected: PropTypes.func.isRequired,
  onUnselected: PropTypes.func.isRequired,
  monoSite: PropTypes.bool,
  errors: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  sites: getSites(state),
  selected: getSelectedSites(state),
  customer: getCustomerId(state),
  errors: getErrors(state),
});

const mapDispatchToProps = dispatch => ({
  onSelected: site => dispatch(selectSite(site)),
  onUnselected: site => dispatch(unselectSite(site)),
  onAdded: site => dispatch(addSite(site)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SiteSelector);



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step1/components/SiteSelector.js